import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from '@material-ui/core';

const CancelDialog = ({ open, onConfirm, onCancel }) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>ביטול</DialogTitle>
      <DialogContent>
        <p>האם את/ה בטוח? שינויים שבוצעו לא ישמרו</p>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary" variant="contained">
          ביטול
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained">
          אישור
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelDialog;
